import { Navigate, Outlet } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import Spinner from "../components/Spinner"; // Import spinner for loading state

const PrivateRoute = ({ allowedRoles, children }) => {
    const { isAuthenticated, user, loading } = useContext(AuthContext);

    if (loading) return <Spinner />; // Show a loading spinner while authentication is being checked

    // If not authenticated, redirect to login
    if (!isAuthenticated) return <Navigate to="/login" />;

    // If user role is not allowed, redirect to unauthorized page
    if (allowedRoles && !allowedRoles.includes(String(user?.userType))) {
        return <Navigate to="/unauthorized" />;
    }

    return children ? children : <Outlet />; //  Use children for both single and nested routes
};

export default PrivateRoute;
